module.exports = __webpack_public_path__ + "img/四川天府新区爱兜兜幼儿园.6c94a773.jpg";